/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Boolvalue1Inputs */

const en_entity_boolvalue1 = /** @type {(inputs: Entity_Boolvalue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boolean Value`)
};

const de_entity_boolvalue1 = /** @type {(inputs: Entity_Boolvalue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boolescher Wert`)
};

/**
* | output |
* | --- |
* | "Boolean Value" |
*
* @param {Entity_Boolvalue1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_boolvalue1 = /** @type {((inputs?: Entity_Boolvalue1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Boolvalue1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_boolvalue1(inputs)
	return de_entity_boolvalue1(inputs)
});
export { entity_boolvalue1 as "entity_boolValue" }